import '@stimulus/polyfills'; // polyfills for Stimulus to work on Safari 8+ and IE 11+
import 'regenerator-runtime/runtime';
import 'core-js/stable/string/ends-with';
import 'core-js/stable/string/pad-start';
